// Minimal fetch wrapper untuk Web Player.
//
// API base URL di-derive dinamis dari window.location supaya saat player
// dibuka dari HP/TV via IP LAN (mis. http://192.168.1.100:5173), API call
// juga ke IP yang sama port 3001, bukan ke localhost (yang di HP = HP sendiri).

function deriveApiBase(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  // Override eksplisit kalau env di-set ke non-localhost (production / staging).
  if (envUrl && !/localhost|127\.0\.0\.1/.test(envUrl)) return envUrl;
  // Local dev: pakai host dari URL saat ini, ganti port ke 3010.
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:3010/v1`;
}

export const API_BASE = deriveApiBase();

export async function apiFetch<T>(
  path: string,
  options: RequestInit & { deviceToken?: string } = {},
): Promise<T> {
  const { deviceToken, headers, ...rest } = options;
  const finalHeaders: Record<string, string> = {
    "Content-Type": "application/json",
    ...((headers as Record<string, string>) ?? {}),
  };
  if (deviceToken) finalHeaders["Authorization"] = `Bearer ${deviceToken}`;

  const res = await fetch(API_BASE + path, { ...rest, headers: finalHeaders });
  if (!res.ok) {
    let detail = "";
    try {
      const body = await res.json();
      if (body?.error?.message) detail = `: ${body.error.message}`;
    } catch {
      // ignore
    }
    throw new Error(`API error ${res.status}${detail}`);
  }
  if (res.status === 204) return null as T;
  return (await res.json()) as T;
}
